
import { macroCondition, getGlobalConfig } from '@embroider/macros';


import defineModule0 from "./-embroider-implicit-modules.js";

import * as amdModule0 from "./app.ts"
import * as amdModule1 from "./config.ts"
import * as amdModule2 from "./icons.ts"
import * as amdModule3 from "./registry.ts"
import * as amdModule4 from "./router.ts"
import * as amdModule5 from "./sample-data/index.ts"
import * as amdModule6 from "./services/page-title.js"
import * as amdModule7 from "./routes/api-docs.gts"
import * as amdModule8 from "./templates/application.gts"
import * as amdModule9 from "./routes/application.ts"
import * as amdModule10 from "./templates/index.gts"
import * as amdModule11 from "./templates/page.gts"

let exportFastbootModules = {};





export default Object.assign(
  {},
defineModule0,
  {
"docs-app/app": amdModule0,
"docs-app/config": amdModule1,
"docs-app/icons": amdModule2,
"docs-app/registry": amdModule3,
"docs-app/router": amdModule4,
"docs-app/sample-data/index": amdModule5,
"docs-app/services/page-title": amdModule6,
"docs-app/routes/api-docs": amdModule7,
"docs-app/templates/application": amdModule8,
"docs-app/routes/application": amdModule9,
"docs-app/templates/index": amdModule10,
"docs-app/templates/page": amdModule11,
  },
  exportFastbootModules
);
